import Box from '@mui/material/Box';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { SxProps, useTheme } from '@mui/material/styles';
import { WizardStore, WizardElementProps, withoutWizardProps } from './Wizard';
import { WizardContainer, WizardContainerProps } from './WizardContainer';

export type WizardDrawerProps = WizardContainerProps &
  DrawerProps & { sx?: SxProps };

export const WizardDrawer = withoutWizardProps(
  (props: WizardDrawerProps & WizardElementProps<WizardStore, string>) => {
    const theme = useTheme();

    return WizardContainer(props, ({ children, open, ...containerProps }) => {
      const { anchor, sx } = props;
      return (
        <Drawer
          onClose={() => {
            return containerProps.go(undefined);
          }}
          anchor={anchor || 'right'}
          open={open}
          sx={{
            backdropFilter: 'blur(3px)',
            '& .MuiDrawer-paper': {
              backdropFilter: 'blur(30px)',
              backgroundColor: 'rgba(0, 44, 102, 0.6) !important',
              borderImageSource: theme.palette.primary.vertical,
              borderImageSlice: 1,
              borderLeft: '2px solid',
              width: '500px',
              mt: 15,
              ...sx,
            },
          }}
          {...containerProps}
        >
          <Box
            overflow={'auto'}
            sx={{
              pt: 2,
              pb: 4,
              px: 4,
              height: 'calc(100% - 60px)',
            }}
          >
            {children}
          </Box>
        </Drawer>
      );
    });
  },
);
